import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../reducers'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { defaultYfDisplay, typeYfDisplay } from '../../enums/yfManagerEnums'
import Icon from '../../components/icon/Icon'
import iconsEnum from '../../enums/iconsEnum'
import { YfManagerModel } from '../../types/yfPopin/yfManagerModel'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            popinThumbnail: {
                height: 48,
                width: 48,
                borderRadius: 50
            },
            requestThumbnail: {
                borderRadius: 50
            }
        }
    )
)

interface AcceptingProps {
    type: string
}

type YFDisplayProps = AcceptingProps

const YFDisplay: React.FC<YFDisplayProps> = (
    {
        type
    }
) => {

    const classes = useStyle()
    const yfManager: YfManagerModel = useSelector((state: RootState) => state.yfManager)

    switch(type) {
        case  typeYfDisplay.POPIN:
            return yfManager.popin_thumbnail === defaultYfDisplay ?
                <Icon size="48px" icon={iconsEnum.Hello} />
                : <img className={classes.popinThumbnail} src={yfManager.popin_thumbnail} alt="face icon" />
        case  typeYfDisplay.REQUEST:
            return yfManager.request_thumbnail === defaultYfDisplay ?
                <img className={classes.requestThumbnail} src="img/default_thumbnail.png" alt="yf Manager icon" />
                : <img className={classes.requestThumbnail} src={yfManager.request_thumbnail} alt="yf Manager icon" />
        case  typeYfDisplay.PICTURE:
            return yfManager.picture === defaultYfDisplay ?
                <img src="img/yfm_img/defaultYFM.png" alt="yf Manager icon" />
                : <img src={yfManager.picture} alt="yf Manager icon" />
        default:
            return <></>
    }

}

export default YFDisplay
